<template>
  <el-table v-if="cutView=='repair'" stripe border style="width: 100%" height="100%" size="mini"
    :data="tableData">
    <el-table-column
      type="index"
      :width="pagination.endIndex >= 1000 ? 80 : 50"
      align="center"
      :index="pagination.beginIndex"
    ></el-table-column>
    <el-table-column prop="month" label="月份" align="center">
      <template slot-scope="scope">
        <span v-if="scope.row.month">{{ scope.row.month }}</span>
        <span v-else>-</span>
      </template>
    </el-table-column>
    <el-table-column prop="month" label="加工工厂" show-overflow-tooltip align="center">
      <template slot-scope="scope">
        <span v-if="scope.row.sapWerks">{{ scope.row.sapWerks }}</span>
        <span v-else>-</span>
      </template>
    </el-table-column>
    <el-table-column prop="month" label="生产工单" show-overflow-tooltip align="center">
      <template slot-scope="scope">
        <span v-if="scope.row.sapOrderNumber">{{ scope.row.sapOrderNumber }}</span>
        <span v-else>-</span>
      </template>
    </el-table-column>
    <el-table-column prop="month" label="销售订单" show-overflow-tooltip align="center">
      <template slot-scope="scope">
        <span v-if="scope.row.customerOrderNumber">{{ scope.row.customerOrderNumber }}</span>
        <span v-else>-</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="sn"
      label="SN"
      align="center"
      show-overflow-tooltip
      min-width="120"
    >
      <template slot-scope="scope">
        <span v-if="scope.row.sn">{{ scope.row.sn }}</span>
        <span v-else>-</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="problem"
      label="故障现象"
      align="center"
      min-width="110"
      show-overflow-tooltip
    >
      <template slot-scope="scope">
        <span v-if="scope.row.problemResultCode">{{ scope.row.problemResultCode.name }}</span>
        <span v-else>-</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="repairContent"
      label="故障类别"
      align="center"
      min-width="100px"
      show-overflow-tooltip
    >
      <template slot-scope="scope">
        <span v-if="scope.row.resultCategory">{{ scope.row.resultCategory.name}}</span>
        <span v-else>-</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="problemReason"
      label="故障原因"
      align="center"
      show-overflow-tooltip
      min-width="150px"
    >
      <template slot-scope="scope">
        <span v-if="scope.row.problemReason">{{
          scope.row.problemReason.name
        }}</span>
        <span v-else>-</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="materiaLocation"
      label="物料位置"
      align="center"
      min-width="100px"
      show-overflow-tooltip
    >
      <template slot-scope="scope">
        <span v-if="scope.row.materialLocation">{{ scope.row.materialLocation}}</span>
        <span v-else>-</span>
      </template>
    </el-table-column>

    <el-table-column
      prop="repairContent"
      label="维修方式"
      align="center"
      min-width="120px"
      show-overflow-tooltip
    >
      <template slot-scope="scope">
        <span v-if="scope.row.repairResultCode">{{ scope.row.repairResultCode.name}}</span>
        <span v-else>-</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="status"
      label="维修状态"
      align="center"
      show-overflow-tooltip
    >
      <template slot-scope="scope">
        <span v-if="scope.row.status.title">{{ scope.row.status.title}}</span>
        <span v-else>-</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="result"
      label="维修结果"
      align="center"
      show-overflow-tooltip
    >
      <template slot-scope="scope">
        <span v-if="scope.row.result">{{ scope.row.result.title }}</span>
        <span v-else>-</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="problemDes"
      label="备注"
      align="center"
      show-overflow-tooltip
    >
      <template slot-scope="scope">
        <span v-if="scope.row.problemDes">{{ scope.row.problemDes }}</span>
        <span v-else>-</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="user"
      label="送修人"
      align="center"
      show-overflow-tooltip
      min-width="100px"
    >
      <template slot-scope="scope">
        <span v-if="scope.row.user">{{ scope.row.user.name }} ({{scope.row.user.employeeNum}})</span>
        <span v-else>-</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="createDateTime"
      label="送修时间"
      align="center"
      show-overflow-tooltip
      min-width="110px"
    >
      <template slot-scope="scope">
        <span v-if="scope.row.startDateTime">{{ scope.row.startDateTime }}</span>
        <span v-else>-</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="repairUser"
      label="维修人"
      align="center"
      show-overflow-tooltip
      min-width="100px"
    >
      <template slot-scope="scope">
        <span v-if="scope.row.repairUser">{{ scope.row.repairUser.name }} ({{scope.row.repairUser.employeeNum}})</span>
        <span v-else>-</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="repairDateTime"
      label="维修时间"
      align="center"
      min-width="110"
      show-overflow-tooltip
    >
      <template slot-scope="scope">
        <span v-if="scope.row.repairDateTime">{{ scope.row.repairDateTime }}</span>
        <span v-else>-</span>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
import { apiRepairSearch} from "@/api/repair.js";
export default {
  props: {
    tabPaneValue: {
      type: String,
    },
    cutView:null,
    searchConditionForm:{type: Object},
    pagination:{}
  },
  computed: {
  },
  components: {
  },
  created() {
  },
  data() {
    return {
      dialogTitle: "【未命名】",
      dialogForm: {
      },
      tableData:null,
      dialogRules: {},
      labelWidth: this.$store.state.labelWidth
    };
  },
  methods: {
    // 表格数据
    async onSearch(remove, callback) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      const res = await apiRepairSearch({
        ...this.searchConditionForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        if (callback) callback();
      }
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.onSearch();
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.onSearch();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.onSearch();
    }
  }
};
</script>
<style lang="less" scoped>
.repairPage {
  width: 100%;
  height: 100%;
  display: flex;
  .myCheckBox {
    line-height: 33px;
    margin-bottom: 16px;
    padding-left: 52px;
  }
}
</style>